import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { motion } from 'framer-motion';
import '../assets/fonts/fonts.css';

const Hero = () => {

  return (
    <Box
      sx={{
        position: 'relative',
        color: 'white',
        textAlign: 'center',
        pt: { xs: 15, md: 18 },
        pb: { xs: 15, md: 18 },
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: `linear-gradient(rgba(158, 28, 32, 0.8), rgba(107, 0, 0, 0.9)), url(${require('../assets/images/banner.jpg')})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          clipPath: 'polygon(0 0, 100% 0, 100% 85%, 50% 100%, 0 85%)',
          zIndex: -1
        }
      }}
    >
      <Container maxWidth="md">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Box sx={{ mb: 5 }}>
            <img 
              src={require('../assets/images/logo.jpg')} 
              alt="CSC VTC Luberon" 
              style={{ 
                maxWidth: '160px', 
                marginBottom: '1.5rem',
                borderRadius: '8px',
              }} 
            />
          </Box>
          
          <Typography 
            variant="h4" 
            component="h1" 
            gutterBottom 
            sx={{ 
              mb: 2,
              fontSize: { xs: '1.8rem', md: '2.5rem' },
              fontFamily: '"Satisfy", cursive'
            }}
          >
            Christophe - Chauffeur Privé
          </Typography>
          
          <Typography 
            variant="h6" 
            className="slogan"
            sx={{ 
              mb: 3, 
              opacity: 0.9,
              maxWidth: '700px',
              mx: 'auto'
            }}
          >
            Au plaisir de vous conduire.
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{ 
              mb: 3, 
              fontWeight: 400,
              opacity: 0.9,
              maxWidth: '700px',
              mx: 'auto'
            }}
          >
            Transfert aéroport, gare, course privée, visite guidée, mise à disposition, soirées-événements, excursions, longues distances, transports réguliers ...
          </Typography>
          
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => window.location.href = '#contact'}
            sx={{
              px: 3,
              py: 1,
              mt: 2,
              bgcolor: 'white',
              color: 'primary.main',
              '&:hover': {
                bgcolor: 'rgba(255,255,255,0.9)',
              }
            }}
          >
            Contactez-nous
          </Button>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Hero;
